module.exports = __webpack_public_path__ + "static/pattern-design-04-89029e6ec655aa215ecb0ea2b3f0ed6b.jpg";